import React, { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("zdc_lang") || "it";
    }
    return "it";
  });

  const switchLang = useCallback((l) => {
    setLang(l);
    if (typeof window !== "undefined") localStorage.setItem("zdc_lang", l);
  }, []);

  const value = useMemo(() => ({
    lang,
    setLang: switchLang,
    t: translations[lang],
  }), [lang, switchLang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
